import { getCorrectBearerJwtForUrl } from 'components/accessControl/getCorrectBearerJwtForUrl';

export const downloadFile = (url: string, name?: string, method = 'GET') => {
  let request = new XMLHttpRequest();
  request.onreadystatechange = function () {
    if (this.readyState === 4 && this.status === 200) {
      const downloadUrl = URL.createObjectURL(request.response);
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = downloadUrl;
      a.download = name || '';
      a.click();
    }
  };
  request.open(method, url, true);
  request.responseType = 'blob';

  request.setRequestHeader('Authorization', `Bearer ${getCorrectBearerJwtForUrl(url ?? '')}`);
  request.send();
};
